/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import {
  CategoryFragmentDoc,
  StatusFragmentDoc,
} from "../components/app/ProjectLabels.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetCategoriesAndStatusesQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetCategoriesAndStatusesQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly categories: ReadonlyArray<{
      readonly __typename: "Category";
      readonly id: c.CategoryId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
    }>;
    readonly statuses: ReadonlyArray<{
      readonly __typename: "Status";
      readonly enforcesReview: boolean;
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
      readonly inLibrary: boolean;
      readonly endorsed: boolean;
      readonly icon: Types.IconType | null;
    }>;
  };
};

export const GetCategoriesAndStatusesDocument = /*#__PURE__*/ gql`
  query GetCategoriesAndStatuses($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      categories {
        ...CategoryFragment
      }
      statuses {
        ...StatusFragment
        enforcesReview
      }
    }
  }
  ${CategoryFragmentDoc}
  ${StatusFragmentDoc}
`;

/**
 * __useGetCategoriesAndStatusesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesAndStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesAndStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesAndStatusesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetCategoriesAndStatusesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCategoriesAndStatusesQuery,
    GetCategoriesAndStatusesQueryVariables
  > &
    (
      | { variables: GetCategoriesAndStatusesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCategoriesAndStatusesQuery,
    GetCategoriesAndStatusesQueryVariables
  >(GetCategoriesAndStatusesDocument, options);
}
export function useGetCategoriesAndStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCategoriesAndStatusesQuery,
    GetCategoriesAndStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCategoriesAndStatusesQuery,
    GetCategoriesAndStatusesQueryVariables
  >(GetCategoriesAndStatusesDocument, options);
}
export function useGetCategoriesAndStatusesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCategoriesAndStatusesQuery,
    GetCategoriesAndStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCategoriesAndStatusesQuery,
    GetCategoriesAndStatusesQueryVariables
  >(GetCategoriesAndStatusesDocument, options);
}
export type GetCategoriesAndStatusesQueryHookResult = ReturnType<
  typeof useGetCategoriesAndStatusesQuery
>;
export type GetCategoriesAndStatusesLazyQueryHookResult = ReturnType<
  typeof useGetCategoriesAndStatusesLazyQuery
>;
export type GetCategoriesAndStatusesSuspenseQueryHookResult = ReturnType<
  typeof useGetCategoriesAndStatusesSuspenseQuery
>;
export type GetCategoriesAndStatusesQueryResult = Apollo.QueryResult<
  GetCategoriesAndStatusesQuery,
  GetCategoriesAndStatusesQueryVariables
>;
